import {
  UPDATE_USER_ID,
  UPDATE_USER_PHONE,
  UPDATE_USER_HEAD,
  SET_USER_TOKEN
} from '../mutation-types'
import superagent from 'superagent'
import wxConfing from '../../assets/js/wx_share.js'

const state = {
  user_id: null,
  user_phone: null,
  user_head: null,
  token: null // for app
}

const mutations = {
  [UPDATE_USER_ID] (state, user_id) {
    state.user_id = user_id
  },
  [UPDATE_USER_PHONE] (state, user_phone) {
    state.user_phone = user_phone
  },
  [UPDATE_USER_HEAD] (state, user_head) {
    state.user_head = user_head
  },
  [SET_USER_TOKEN] (state, token) {
    state.token = token
  }
}

const actions = {
  // 设置用户信息
  setUserInfo ({ commit }, params) {
    commit('UPDATE_USER_ID', params.user_id ? params.user_id : '')
    commit('UPDATE_USER_PHONE', params.mobile ? params.mobile : '')
    commit('SET_USER_TOKEN', params.token ? params.token : '')
  },
  // 获取验证码
  getCode ({commit}, params) {
    if (params) {
      params.channel = '1'
    }
    return new Promise(function (resolve, reject) {
      superagent
      .post('/index.php/sms/code/send_new')
      .send(params)
      .type('form')
      .end(function (err, res) {
        if (err) throw err
        let _res = JSON.parse(res.text)
        if (_res.result === '0000') {
          resolve(_res)
        } else {
          reject(_res)
        }
      })
    })
  },
  // 用户登入
  userLogin ({ commit }, params) {
    return new Promise(function (resolve, reject) {
      superagent
      .post('/index.php/users/login/login_new')
      .set('Accept', 'application/json')
      .send(params)
      .type('form')
      .end(function (err, res) {
        if (err) throw err
        let _res = JSON.parse(res.text)
        if (_res.result === '0000') {
          resolve(_res)
        } else {
          reject(_res)
        }
      })
    })
  },
  // 用户授权登入
  authorLogin ({ commit }, params) {
    return new Promise(function (resolve, reject) {
      superagent
      .post('/index.php/zuolinauth/zuolin_login')
      .set('Accept', 'application/json')
      .send(params)
      .type('form')
      .end(function (err, res) {
        if (err) throw err
        let _res = JSON.parse(res.text)
        if (_res.result === '0000') {
          resolve(_res)
        } else {
          reject(_res)
        }
      })
    })
  },
  // 用户登出
  userLogout ({ commit }, params) {
    return new Promise(function (resolve, reject) {
      superagent
      .post('/index.php/users/mine/login_out')
      .set('Accept', 'application/json')
      .send(params)
      .type('form')
      .end(function (err, res) {
        if (err) throw err
        let _res = JSON.parse(res.text)
        if (_res.result === '0000') {
          resolve(_res)
        } else {
          reject(_res)
        }
      })
    })
  },
  // 自动登入
  autoLogin ({ commit }) {
    return new Promise(function (resolve, reject) {
      superagent
      .post('/index.php/users/mine/auto_login')
      .type('form')
      .end(function (err, res) {
        if (err) throw err
        let _res = JSON.parse(res.text)
        if (_res.result === '0000') {
          // 已经登入
          if (_res.data.login) {
            commit(UPDATE_USER_ID, _res.data.ltb_user_id)
            commit(UPDATE_USER_PHONE, _res.data.user_name)
            commit(UPDATE_USER_HEAD, _res.data.user_head_img)
          } else {
            // 用户未登入且在微信环境且第一次跳转wx_login
            // if (common.state.is_weixin_browser && !_res.data.wx_login_tried) {
            //   window.location = 'http://wxtest.dudubashi.com/index.php/users/weixin/wx_login'
            // }
          }
          resolve(_res)
        } else {
          reject(_res)
        }
      })
    })
  },
  // 微信分享
  wxShare ({ commit }) {
    return new Promise(function (resolve, reject) {
      superagent
      .post('/index.php/users/weixin/get_wx_sign_package')
      .send({
        share_url: window.location.href
      })
      .type('form')
      .end(function (err, res) {
        if (err) throw err
        let _res
        if (res.text && res.text.result) {
          _res = JSON.parse(res.text)
        } else {
          _res = JSON.parse(res.xhr.response)
        }
        if (_res && _res.result === '0000') {
          wxConfing(_res.data)
        } else {}
      })
    })
  }
}

export default {
  actions,
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/userInfo.js